/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { timestampToDateTime } from "../Helpers/common";
import { UrlPreview, previewLinkIcon } from "../Helpers/chatCommon";
import AttachmentsFiles from "./attachmentFile";
import { setActiveThreadChat } from "../redux/chatSlice";
import store from "../../store";

const ChatboardThreadIncoming = ({ value, userInfo }) => {
  const allAttendeeList = useSelector((state) => state.call.allAttendeeList);

  const deletedMessageIds = useSelector(
    (state) => state.chat.deletedMessageIds,
  );

  let username = userInfo.name;
  let useravtar = userInfo.user_profile_image;

  const deleteChatData = useSelector((state) => state.chat.deleteChatData);

  useEffect(() => {
    if (deleteChatData?.messageID) {
      let deletedID = document.getElementById(deleteChatData.messageID);
      if (deletedID) {
        deletedID.classList.add("chat_row_hide");
      }
    }
  }, [deleteChatData]);

  if (userInfo.type == "group") {
    allAttendeeList.some((v) => {
      if (v?.user_id == value.senderID) {
        username = v.name;
        useravtar = v.user_profile_image;
      }
    });
  }
  let IsNewLineExist = null;
  if (value.message !== "c2-attach-files") {
    IsNewLineExist = /\r|\n/.exec(value.message);
  }

  const isUserOnline = useMemo(() => {
    return allAttendeeList.find((item) => item.user_id === value.senderID)
      ?.online
      ? true
      : false;
  }, [allAttendeeList, value.senderID]);

  const newMessage =
    IsNewLineExist !== null
      ? value.preview &&
        Array.isArray(value.preview) &&
        value.preview.length > 0
        ? value.message_array.join(" ")
        : value.message.replace(/ /g, "&nbsp;")
      : value.message.replace(/ /g, "&nbsp;");

  const lengthOfSplitMessage = newMessage?.split("\n").length;

  const handleReplyToThread = (value) => {
    store.dispatch(setActiveThreadChat(value));
  };

  return (
    <>
      <div
        className={`chat_row $ ${
          deletedMessageIds?.includes(value?.id) ? "chat_row_hide" : ""
        } ${value?.pinned && "highlight"}`}
        id={value.id}
        key={value.id}
      >
        <div className="w-100 d-flex flex-column  max-w-100">
          <div className="d-flex">
            <div className="avatar">
              {useravtar ? (
                <img className="h-100" src={`${useravtar}`} alt="avtar"></img>
              ) : (
                <svg viewBox="3 2 18 19">
                  <path
                    fill="#425b76"
                    d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                  ></path>
                </svg>
              )}
              <span className={`status ${isUserOnline && "online"}`}></span>
            </div>

            <div
              className={`bubble inner-bubble ${
                value.isReply === true && "reply"
              }`}
            >
              {value.isReply === true && (
                <h3 className="Name-messenger">{username} </h3>
              )}

              <div className={`${value.isReply === true && "reply-inner"}`}>
                {value.isReply === true ? (
                  <h3 className="Name-messenger flex-column align-items-start">
                    <div>
                      <p
                        className="break-words text-grey"
                        dangerouslySetInnerHTML={{ __html: value.earlyMessage }}
                      />
                      <div className="time ml-0 mt-1">
                        {allAttendeeList?.find(
                          (findItem) =>
                            findItem.user_id === value.earlyMsgSenderID,
                        )?.name ?? ""}
                        , {timestampToDateTime(value.earlyMsgTimestamp)}
                      </div>
                    </div>
                  </h3>
                ) : (
                  <h3 className="Name-messenger">
                    {username}
                    <div className="time">
                      {timestampToDateTime(value.timestamp)}
                    </div>
                  </h3>
                )}
              </div>

              {value.attachments !== undefined &&
              value.attachments.length > 0 &&
              value.message === "c2-attach-files" ? (
                <div className="d-flex file_send_info gap-10 flex-wrap">
                  {value?.attachment_caption ? (
                    <div className="file_send_info_inner">
                      <div className="d-flex flex-wrap gap-y-10">
                        {value.attachments.map(
                          (attachmentItem, attachmentIndex) => {
                            return (
                              <div className="w-100" key={attachmentIndex}>
                                {/* eslint-disable-next-line indent */}
                                {/* eslint-disable-next-line indent */}
                                <AttachmentsFiles
                                  attachmentItem={attachmentItem}
                                  messageDetail={value}
                                />
                              </div>
                            );
                          },
                        )}
                      </div>

                      <div>
                        {value?.attachment_caption && (
                          <span>
                            <p
                              className="break-words"
                              dangerouslySetInnerHTML={{
                                __html: value?.attachment_caption,
                              }}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                  ) : (
                    value.attachments.map((attachmentItem, attachmentIndex) => {
                      return (
                        <div className="w-100" key={attachmentIndex}>
                          {/* eslint-disable-next-line indent */}
                          {/* eslint-disable-next-line indent */}
                          <AttachmentsFiles
                            attachmentItem={attachmentItem}
                            messageDetail={value}
                          />
                        </div>
                      );
                    })
                  )}
                </div>
              ) : IsNewLineExist !== null ? (
                <>
                  {newMessage?.split("\n").map((str, index) => (
                    <>
                      <div
                        key={index}
                        className="d-flex file_send_info gap-10 flex-wrap"
                      >
                        <p
                          className="break-words"
                          dangerouslySetInnerHTML={{ __html: str }}
                        />
                        {previewLinkIcon(value)}
                        {value.edited === true &&
                          index === lengthOfSplitMessage - 1 && (
                            <p className="edit_message_display">(edited)</p>
                          )}
                      </div>
                    </>
                  ))}
                  {value?.preview ? UrlPreview(value?.preview) : null}
                </>
              ) : (
                <>
                  <div className="d-flex justify-content-between gap-10 align-items-start">
                    <div className="d-flex file_send_info gap-10 flex-wrap">
                      <p
                        className="break-words"
                        dangerouslySetInnerHTML={{
                          __html:
                            value.preview &&
                            Array.isArray(value.preview) &&
                            value.preview.length > 0
                              ? value.message_array.join(" ")
                              : value.message,
                        }}
                      />
                      {previewLinkIcon(value)}
                      {value.edited === true && (
                        <p className="edit_message_display">(edited)</p>
                      )}
                    </div>

                    <div
                      className="d-flex align-items-center justify-content-end text-orange cursor-pointer no-whitespace"
                      onClick={() => handleReplyToThread(value)}
                    >
                      <span className="chat_count d-flex align-items-center justify-content-center align-self-center mr-2">
                        {value?.count || 0}
                      </span>
                    </div>
                  </div>
                  {value?.preview ? UrlPreview(value?.preview) : null}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(ChatboardThreadIncoming);
